/* eslint-disable no-shadow */
/* eslint-disable no-fallthrough */
/* eslint-disable no-param-reassign */
const thresholdTypeBGFieldCheck = (formState, form) => {
  if (
    formState.is_threshold
    && formState.contractType
    && formState.contractType === "businessGuaranteed"
    && formState.unit === "perDay"
    && !formState.thresholdTypeBG) {
    form.thresholdTypeBG = "Required";
  }
};
const kmWisePaidAmountFieldCheck = (formState, form) => {
  if (
    formState.unit
    && formState.contractType === "businessGuaranteed"
    && formState.unit === "perKm"
    && !formState.kmWisePaidAmount
  ) {
    form.kmWisePaidAmount = "Required";
  }
};
const dayWisePaidAmountFieldCheck = (formState, form) => {
  if (
    formState.unit
    && formState.contractType === "businessGuaranteed"
    && formState.unit === "perDay"
    && !formState.dayWisePaidAmount
  ) {
    form.dayWisePaidAmount = "Required";
  }
};
const kmWiseThresholdFieldCheck = (formState, form) => {
  if (
    formState.is_threshold
    && formState.contractType === "businessGuaranteed"
    && formState.unit === "perKm"
    && !formState.kmWiseThreshold
  ) {
    form.kmWiseThreshold = "Required";
  }
};
const penaltyFieldCheck = (formState, form) => {
  if (
    formState.is_threshold
    && formState.contractType === "businessGuaranteed"
    && formState.unit === "perKm" && !formState.penalty
  ) {
    form.penalty = "Required";
  }
};
const epkmBGFieldCheck = (formState, form) => {
  if (
    formState.is_threshold
    && formState.contractType === "businessGuaranteed"
    && formState.unit === "perDay"
    && !formState.epkmBG
  ) {
    form.epkmBG = "Required";
  }
};
const travelKmBGFieldCheck = (formState, form) => {
  if (
    formState.is_threshold
    && formState.contractType === "businessGuaranteed"
    && formState.unit === "perDay"
    && !formState.travelKmBG) {
    form.travelKmBG = "Required";
  }
};
const flatFeeFieldCheck = (formState, form) => {
  if (formState.contractType && formState.contractType === "flatFee") {
    if (!formState.flatFee) {
      form.flatFee = "Required";
    }
    if (!formState.flatFeeOn) {
      form.flatFeeOn = "Required";
    }
    if (formState.flatFeeOn === "perRide" && !formState.minimumRides) {
      form.minimumRides = "Required";
    }
  }
};
const cappingAmountFieldCheck = (formState, form) => {
  if (
    formState.is_capping
    && formState.contractType === "businessGuaranteed"
    && formState.baseline === "perDay"
    && !formState.cappingAmount
  ) {
    form.cappingAmount = "Required";
  }
};
const percentageCriteriaFieldCheck = (formState, form) => {
  if (
    formState.criteria
    && formState.contractType === "revenueShare"
    && formState.criteria === "percentageBased"
    && !formState.percentageCriteria
  ) {
    form.percentageCriteria = "Required";
  }
};
const ticketCountTypeFieldCheck = (formState, form) => {
  if (
    formState.criteria
    && formState.contractType === "revenueShare"
    && formState.criteria === "perTicketBased"
    && !formState.ticketCountType
  ) {
    form.ticketCountType = "Required";
  }
};
const percentageFieldCheck = (formState, form) => {
  if (
    formState.criteria
    && formState.contractType === "revenueShare"
    && formState.criteria === "percentageBased"
  ) {
    if ((formState.percentageCriteria === "totalCollection" || formState.percentageCriteria === "originalDigitalAmount" || (formState.percentageCriteria === "cardCollection" && !formState.showCardAndMobile)) && !formState.percentage) {
      form.percentage = "Required";
    } else if (formState.percentageCriteria === "cardCollection" && formState.showCardAndMobile) {
      if (!formState.isMobilePercentageCriteria && !formState.isCardPercentageCriteria) {
        form.cardCollectionPercentageCriteria = "Please select at least one type";
      }
      if (formState.isMobilePercentageCriteria && !formState.mobileDigitalPercentage) {
        form.mobileDigitalPercentage = "Required";
      }
      if (formState.isCardPercentageCriteria && !formState.cardDigitalPercentage) {
        form.cardDigitalPercentage = "Required";
      }
    }
  }
};
const feeFieldCheck = (formState, form) => {
  if (
    formState.criteria
    && formState.contractType === "revenueShare"
    && formState.criteria === "perTicketBased"
    && !formState.fee
  ) {
    form.fee = "Required";
  }
};

const validateFields = (field, formState, form) => {
  switch (field) {
    case "contractType":
      if (!formState.contractType) {
        form.contractType = "Required";
      }
      break;
    case "unit":
      if (formState.contractType && formState.contractType === "businessGuaranteed" && !formState.unit) {
        form.unit = "Required";
      }
      break;
    case "thresholdTypeBG":
      thresholdTypeBGFieldCheck(formState, form);
      break;
    case "kmWisePaidAmount":
      kmWisePaidAmountFieldCheck(formState, form);
      break;
    case "dayWisePaidAmount":
      dayWisePaidAmountFieldCheck(formState, form);
      break;
    // case "thresholdAmount":
    //   if (
    //     formState.is_threshold &&
    //     formState.contractType === "businessGuaranteed" &&
    //     formState.unit === "perDay" &&
    //     !formState.thresholdAmount
    //   ) {
    //     form["thresholdAmount"] = "Required";
    //   }
    //   break;
    case "kmWiseThreshold":
      kmWiseThresholdFieldCheck(formState, form);
      break;
    case "penalty":
      penaltyFieldCheck(formState, form);
      break;
    case "epkmBG":
      epkmBGFieldCheck(formState, form);
      break;
    case "travelKmBG":
      travelKmBGFieldCheck(formState, form);
      break;
    case "criteria":
      if (formState.contractType && formState.contractType === "revenueShare" && !formState.criteria) {
        form.criteria = "Required";
      }
    case "baselineCriteria":
      if (formState.contractType && formState.contractType === "baseline" && !formState.baselineCriteria) {
        form.baselineCriteria = "Required";
      }
    case "flatFeeCriteria":
      if (formState.contractType && formState.contractType === "flatFee" && !formState.flatFeeCriteria) {
        form.flatFeeCriteria = "Required";
      }
      break;
    case "flatFee":
      flatFeeFieldCheck(formState, form);
      break;
    case "cappingAmount":
      cappingAmountFieldCheck(formState, form);
      break;
    case "percentageCriteria":
      percentageCriteriaFieldCheck(formState, form);
      break;
    case "ticketCountType":
      ticketCountTypeFieldCheck(formState, form);
      break;
    case "percentage":
      percentageFieldCheck(formState, form);
      break;
    case "fee":
      feeFieldCheck(formState, form);
      break;
    default:
      break;
  }
};

const validateNestedFields = (field, formState, selfState, raw) => {
  switch (field) {
    case "percentage":
      if (
        formState.contractType === "baseline"
        && formState.baselineCriteria === "percentageBased"
        && !selfState.percentage
      ) {
        raw.percentage = "Required";
      }
      break;
    case "percentageCriteria":
      if (formState.contractType === "baseline" && !selfState.percentageCriteria) {
        raw.percentageCriteria = "Required";
      }
      break;
    case "baselineFlatFee":
      if (
        formState.contractType === "baseline"
        && formState.baselineCriteria === "flatFeeBased"
        && !selfState.baselineFlatFee
      ) {
        raw.baselineFlatFee = "Required";
      }
      break;
    case "baseline":
      if (formState.contractType === "baseline" && !selfState.baseline) {
        raw.baseline = "Required";
      }
      break;
    default:
      break;
  }
};

const validateBusinessDetail = (formState) => {
  const businessDetailError = [];
  const businessDetailStepError = [];
  if (formState.isNextClicked) {
    const { businessDetails } = formState;
    if (businessDetails && businessDetails.length > 0) {
      businessDetails.forEach((oneFormState) => {
        const form = {};
        const baselinePercentage = [];
        const baselineErrorPercentage = [];
        Object.entries(oneFormState).forEach(([key]) => {
          if (key !== "baselinePercentage") {
            validateFields(key, oneFormState, form);
          } else if (
            key === "baselinePercentage"
            && oneFormState
            && oneFormState.baselinePercentage
            && oneFormState.baselinePercentage.length > 0
          ) {
            oneFormState.baselinePercentage.forEach((One) => {
              const raw = {};
              Object.entries(One).forEach(([oneKey]) => {
                validateNestedFields(oneKey, oneFormState, One, raw);
              });
              if (raw && Object.keys(raw).length > 0) {
                baselinePercentage.push(raw);
              }
              baselineErrorPercentage.push(raw);
            });
          }
        });
        if (baselinePercentage && baselinePercentage.length > 0) {
          form.baselinePercentage = baselinePercentage;
        }
        if (form && Object.keys(form).length > 0) {
          businessDetailStepError.push(form);
        }
        form.baselinePercentage = baselineErrorPercentage;
        businessDetailError.push(form);
      });
    }
  }
  return { businessDetailError, businessDetailStepError };
};

export default validateBusinessDetail;
